export default __webpack_public_path__ + "static/tablet_sek2_KV10-2b16a688cb11043f9e81de4b8712f761.mp4";